
import React from "react";

import './RadioSelector.css';

interface RadioSelectorProps {
    label_text: string;
    options: Record<string, boolean>;
    selected: string;
    onchange: (opt: string) => void;
}

class RadioSelector extends React.Component<RadioSelectorProps> {
    constructor(props: RadioSelectorProps) {
        super(props);
    }

    changeRadio(opt: string) {
        if (this.props['onchange']) {
            this.props['onchange'](opt);
        }
    }

    render() {
        return (<div className='control radio'>
            <span className='radio-label'>{this.props['label_text']}</span>
            {Object.entries(this.props['options']).map(([opt, enabled]) => {
                let cls = 'disabled';
                let clickhandler = () => {}
                if (enabled) {
                    cls = opt == this.props['selected'] ? 'selected' : '';
                    clickhandler = () => this.changeRadio(opt);
                }
                return <div key={opt} className={cls} onClick={clickhandler}>{opt}</div>;
            })}
        </div>);
    }
}

export default RadioSelector;